import React, { memo, useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import HotspotMedia from '../../../common/ImageHotspot/HotspotMedia';
import PoweredBy from '../../../common/PoweredBy';
import FlagIcon from '../../../icons/FlagIcon';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import { UseWindowDimensions } from '../../collage/utils';
import { IModal } from './interfaces';
import './modal.scss';
import ReadMoreReadLess from '../../../common/ReadMoreReadLess';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

dayjs.extend(relativeTime);
import { MdOutlineClose } from 'react-icons/md';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GoMute, GoUnmute } from 'react-icons/go';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import { Navigation, Virtual, EffectCoverflow } from 'swiper/modules';
import { getCurrentSymbol, PriceDisplay } from '../../../Helpers/Helpers';
import AnimatedModal from '../AnimatedModal';
import { FaFacebookF, FaLinkedinIn, FaShare, FaWhatsapp } from 'react-icons/fa';
import { BsCopy } from 'react-icons/bs';
import { FaTiktok } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';
import ProductsOverlay from '../components/ProductsOverlay';
import WocommerceModalRight from '../components/WocommerceModalRight';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/virtual';
import 'swiper/css/effect-coverflow';
import PostRating from '../../PostRating';
import ProductReviews from '../../ProductReviews';
import { IoClose } from 'react-icons/io5';
import UpdatedContent from '../ModalContent/UpdatedContent';
import InspirationContent from '../ModalContent/InspirationContent';
import { CLICK_EVENTS, SWIPE_INDICATOR_KEY } from '../../../contants';
import { SwipeMoreIndicator } from './SwipeMoreIndicator';

const ProductOutside = React.lazy(() => import('../components/ProductOutside'));
const ShopifyModalRight = React.lazy(() => import('../components/ShopifyModalRight'));
const AdditionalModalRight = React.lazy(() => import('../components/AdditionalModalRight'));

const Modal: React.FC<IModal> = ({ isOpen, onClose }) => {
  const {
    data,
    layout,
    setReportModalData,
    onReportModalOpen,
    albumData,
    albumId,
    isShopify,
    shopifyData,
    quantity,
    setQuantity,
    guid,
    isWooCommerceSite,
    fetchNextPost,
    clickMutate,
    selectedProduct,
    isGoogle,
    setAlbumId,
    setProductOverlayIndex,
  } = useDisplayWidgetContext();
  const isFlag = layout?.gallerySettings?.flagInappropriate;
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [isHotspot, setIsHotspot] = React.useState(false);
  const [showSharePopup, setShowSharePopup] = React.useState(false);
  const [productReview, setProductReview] = React.useState({});
  const [shouldRenderSwiper, setShouldRenderSwiper] = React.useState(null);

  const [hasSwipedOnce, setHasSwipedOnce] = React.useState(() => {
    try {
      return localStorage.getItem(SWIPE_INDICATOR_KEY) === 'true';
    } catch {
      return false;
    }
  });
  const [showIndicatorOnThisSlide, setShowIndicatorOnThisSlide] = React.useState(false);

  React.useEffect(() => {
    if (isOpen && activeIndex !== null && activeIndex !== undefined) {
      const shouldShow = !hasSwipedOnce;
      const timer = setTimeout(() => {
        setShowIndicatorOnThisSlide(shouldShow);
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [isOpen, activeIndex]);

  React.useEffect(() => {
    if (!isOpen) {
      setShowIndicatorOnThisSlide(false);
    }
  }, [isOpen]);

  React.useEffect(() => {
    setIsHotspot(false);
  }, [isOpen, activeIndex]);

  React.useEffect(() => {
    albumData?.map((row, id) => {
      if (row?.id == albumId) setActiveIndex(id);
    });
  }, [albumId]);

  const products = albumData[activeIndex]?.products;
  React.useEffect(() => {
    return () => {
      setQuantity(1);
    };
  }, []);

  const updateHeight = () => {
    // const ht: number = window.visualViewport.height;
    // const short_video_container = document.querySelector('.short_video_container');
    // short_video_container['style']['height'] = ht + 'px';
  };

  const [isMuted, setIsMuted] = React.useState(true);

  React.useEffect(() => {
    setIsMuted(layout?.popupSettings?.popupVideoMute !== false);
  }, [layout?.popupSettings?.popupVideoMute]);

  const toggleMute = (index) => {
    const modalContainer = document.getElementById('idk_modal_container');
    const currentVideoElement = modalContainer.querySelector(`[id="slide_${index}"]`)?.getElementsByTagName('video');
    if (currentVideoElement.length > 0) {
      if (currentVideoElement[0].muted) {
        setIsMuted(false);
        currentVideoElement[0].muted = false;
      } else {
        setIsMuted(true);
        currentVideoElement[0].muted = true;
      }
    }
  };

  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const handleSlide = (slider: any) => {
    const modalContainer = document.getElementById('idk_modal_container');
    const currentVideoElement = modalContainer
      .querySelector(`[id="slide_${slider.activeIndex}"]`)
      ?.getElementsByTagName('video');
    const previousVideoElement = modalContainer
      .querySelector(`[id="slide_${slider.previousIndex}"]`)
      ?.getElementsByTagName('video');
    if (currentVideoElement?.length > 0) {
      if (!isMuted) {
        currentVideoElement[0].muted = false;
      } else {
        currentVideoElement[0].muted = true;
      }
      currentVideoElement[0].currentTime = 0;
      if (!previousVideoElement?.[0]?.paused) {
        currentVideoElement?.[0].play();
      }
    }
    if (previousVideoElement?.length > 0) {
      previousVideoElement[0].pause();
    }
  };

  const onVideoComplete = () => {
    if (layout?.videoSettings?.disableAutoPlayNext === false) {
      if (albumData?.length - 1 == activeIndex) {
        setActiveIndex(0);
      } else {
        setActiveIndex(activeIndex + 1);
      }
    }
  };

  const handleSharePopup = () => {
    setShowSharePopup((prevState) => !prevState);
  };

  const swiperRef = React.useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  useEffect(() => {
    setAlbumId(albumData[activeIndex]?.id);
    if (activeIndex !== null && albumData[activeIndex]?.products?.length > 0) {
      if (layout?.productsSettings?.showProductReviews) {
        albumData[activeIndex].products.forEach((product) => {
          if (product?.id_from_product) {
            fetchProductReview(product.id_from_product);
          }
        });
      }
    }
  }, [activeIndex]);

  useEffect(() => {
    if (isOpen) {
      const timeout = setTimeout(() => {
        if (swiperRef.current) {
          swiperRef.current.update();
        }
      }, 200);

      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  const fetchProductReview = async (productId: string) => {
    let productReviewUrl = '';
    if (layout.productsSettings.ratingPlatform === 'trustoo') {
      productReviewUrl = `https://api.trustoo.io/api/v1/reviews/get_product_reviews?shop_id=${layout.productsSettings.platformKey}&limit=6&page=1&product_id=${productId}&sort_by=comprehensive-descending&t=1756047799041`;
    }
    if (layout.productsSettings.ratingPlatform === 'bazaarvoice') {
      productReviewUrl = `https://apps.bazaarvoice.com/api/data/reviews.json?apiversion=5.4&passkey=${layout.productsSettings.platformKey}&stats=Reviews&filter=ContentLocale:en_ZA,en*,es*,it*,pt*,ro*,ru*,uk*,fr*&filter=ProductId:${productId}`;
    }
    if (productReviewUrl) {
      try {
        const response = await fetch(productReviewUrl);
        const data = await response.json();
        setProductReview((prevState) => ({ ...prevState, [productId]: data.Results.length > 0 ? data.Results : null }));
      } catch (error) {
        console.error('Error fetching product reviews:', error);
      }
    }
  };

  const { width } = UseWindowDimensions();

  React.useEffect(() => {
    if (width < 600 && activeIndex !== null && !isGoogle) {
      setShouldRenderSwiper(true);
    } else {
      setShouldRenderSwiper(false);
    }
  }, [width, activeIndex]);

  return (
    <AnimatedModal isOpen={isOpen} layout={layout}>
      <style>{`${layout.gallerySettings.customCSS}`}</style>
      {layout?.gallerySettings?.modalDesign === 'square' ? (
        <>
          <UpdatedContent activeIndex={activeIndex} setActiveIndex={setActiveIndex} onClose={onClose} />
        </>
      ) : layout?.gallerySettings?.modalDesign === 'inspiration' ? (
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          modules={[Virtual]}
          virtual={{
            enabled: true,
            slides: albumData,
            addSlidesAfter: 2,
            addSlidesBefore: 2,
          }}
          initialSlide={activeIndex ?? 0}
          onSlideChange={(slider) => {
            setActiveIndex(slider.activeIndex);
            clickMutate(albumData[`${slider.activeIndex}`]?.id);
            handleSlide(slider);
            if (slider.isEnd) {
              fetchNextPost();
            }
          }}
        >
          {albumData.map((mediaData, index) => {
            return (
              <SwiperSlide key={index}>
                <InspirationContent
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                  mediaData={mediaData}
                  onClose={onClose}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <>
          {layout?.gallerySettings?.modalDesign !== 'carousel' && (
            <>
              {' '}
              <idk-div
                style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}
                class="zid-hidden md:zid-flex zid-items-center zid-justify-center zid-text-[30px] zid-text-[#fff] zid-bg-transparent zid-cursor-pointer"
                onClick={() => {
                  setProductOverlayIndex(0);
                  clickMutate(albumData[activeIndex]?.id);
                  if (activeIndex == 0) setActiveIndex(albumData.length - 1);
                  else setActiveIndex(activeIndex - 1);
                }}
              >
                <IoIosArrowBack />
              </idk-div>
              <idk-div
                class="zid-hidden md:zid-flex zid-items-center zid-text-[30px] zid-text-[#fff] zid-bg-transparent zid-min-w-[25px] zid-cursor-pointer"
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                onClick={() => {
                  setProductOverlayIndex(0);
                  clickMutate(albumData[activeIndex]?.id);
                  if (activeIndex == albumData.length - 1) setActiveIndex(0);
                  else setActiveIndex(activeIndex + 1);
                }}
              >
                <IoIosArrowForward />
              </idk-div>
            </>
          )}
          <idk-div
            class="zid-flex zid-items-center zid-justify-center zid-mx-auto"
            style={{
              height: width <= 576 ? (isGoogle ? '100%' : '100vh') : '100%',
              flexDirection: 'row',
              maxWidth: '1000px',
            }}
          >
            <idk-div
              class="zid-justify-center zid-items-center zid-flex zid-inset-0"
              style={{
                width: width <= 576 && !isGoogle ? '100%' : 'max-content',
                height: width <= 576 ? '100%' : isGoogle ? '100%' : '90vh',
              }}
            >
              {albumData.length > 0 &&
                (shouldRenderSwiper ? (
                  <idk-div
                    class="short_video_container zid-w-[100vw]"
                    style={{ height: window?.visualViewport?.height || '100vh' }}
                  >
                    <style>{`.swiper-wrapper{ height: 100%!important}`}</style>
                    <Swiper
                      key={selectedProduct ? 'no-swipe' : 'swipe'}
                      autoHeight
                      onSwiper={(swiper) => (swiperRef.current = swiper)}
                      direction="vertical"
                      slidesPerView={1}
                      speed={400}
                      initialSlide={activeIndex ?? 0}
                      allowTouchMove={selectedProduct ? false : true}
                      onSlideChange={(slider) => {
                        setActiveIndex(slider.activeIndex);
                        setHasSwipedOnce(true);
                        setShowIndicatorOnThisSlide(false);
                        try {
                          localStorage.setItem(SWIPE_INDICATOR_KEY, 'true');
                        } catch (e) {
                          console.error('Could not save to localStorage:', e);
                        }
                        clickMutate(albumData[`${slider.activeIndex}`]?.id);
                        handleSlide(slider);
                        if (slider.isEnd) {
                          fetchNextPost();
                        }
                      }}
                      observer={true}
                      observeParents={true}
                      observeSlideChildren={true}
                      modules={[Navigation, Virtual]}
                      navigation={{
                        nextEl: '.image-swiper-button-next',
                        prevEl: '.image-swiper-button-prev',
                        disabledClass: 'swiper-button-disabled',
                      }}
                      virtual={{
                        enabled: true,
                        slides: albumData,
                        addSlidesAfter: 2,
                        addSlidesBefore: 2,
                      }}
                      touchReleaseOnEdges={true} // Allow smooth release at edges
                      passiveListeners={true} // Prevent touch event conflicts
                      freeMode={false} // Allows smoother swiping
                    >
                      {albumData.map((mediaData: any, index: number) => {
                        return (
                          <SwiperSlide virtualIndex={index} id={`slide_${index}`} key={index} className="zid-h-full">
                            <idk-div class="zid-bg-white zid-w-full zid-h-full zid-rounded">
                              <idk-div class="zid-flex zid-flex-col sm:zid-flex-row zid-h-full zid-relative zid-rounded">
                                {layout?.videoSettings?.enableSwipeMore &&
                                  index === activeIndex &&
                                  showIndicatorOnThisSlide && <SwipeMoreIndicator />}
                                <idk-div
                                  class="zid-flex zid-w-full zid-h-full zid-bg-white zid-relative"
                                  style={{ flexDirection: width <= 600 ? 'column' : 'row' }}
                                >
                                  <idk-div
                                    class="zid-absolute zid-w-full zid-z-[999999] zid-top-0"
                                    id="idk_top_content"
                                  ></idk-div>
                                  <idk-div class="lg:zid-hidden zid-items-center zid-gap-2 zid-p-3 zid-border-b zid-border-b-slate-200 zid-hidden zid-md-flex">
                                    <idk-div
                                      class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                                        albumData[index]?.profilePic != '0' &&
                                        albumData[index]?.profilePic != undefined &&
                                        albumData[index]?.username != '0' &&
                                        albumData[index]?.username != undefined
                                          ? ''
                                          : 'zid-invisible'
                                      }`}
                                    >
                                      {albumData[index]?.profilePic ? (
                                        <img
                                          src={albumData[index]?.profilePic}
                                          className="zid-h-full zid-w-full zid-rounded-full"
                                          loading="lazy"
                                          onError={(e) => {
                                            const currentSrc = e.currentTarget.src;

                                            // Only replace once if still pointing to idukki-cdn.com
                                            if (currentSrc.includes('idukki-cdn.com')) {
                                              e.currentTarget.onerror = null;
                                              e.currentTarget.src = albumData[index]?.profilePic?.replace(
                                                'https://idukki-cdn.com',
                                                'https://assets.idukki.io',
                                              );
                                            }
                                          }}
                                        ></img>
                                      ) : (
                                        albumData[index]?.username?.charAt(0)?.toUpperCase()
                                      )}
                                    </idk-div>
                                    {albumData[index]?.username != '0' && (
                                      <idk-div class="zid-text-black">{albumData[index]?.username}</idk-div>
                                    )}
                                  </idk-div>
                                  <idk-div
                                    class="zid-relative zid-h-full"
                                    style={{ maxWidth: width <= 600 ? '100%' : '50%' }}
                                  >
                                    {mediaData.media_type == 'VIDEO' && (
                                      <idk-div
                                        class="idk_mute_modal_icon zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px]"
                                        style={{ position: 'absolute', top: '15px', left: '10px', zIndex: 99999999 }}
                                        onClick={() => toggleMute(index)}
                                      >
                                        {isMuted ? (
                                          <GoMute fontSize="18px" color="#ffffff" />
                                        ) : (
                                          <GoUnmute fontSize="18px" color="#ffffff" />
                                        )}
                                      </idk-div>
                                    )}
                                    <HotspotMedia
                                      layout={layout}
                                      isSwiper={true}
                                      onVideoComplete={onVideoComplete}
                                      autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
                                      isMuted={layout?.popupSettings?.popupVideoMute}
                                      playFunctionality={true}
                                      row={albumData[index]}
                                      isModal={true}
                                      style={{
                                        height: '100%',
                                        width: '100%',
                                        objectFit: 'cover',
                                        maxHeight: isGoogle ? '90vh' : '100%',
                                      }}
                                    />
                                    <idk-div
                                      class="idk_close_modal_icon zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px]"
                                      style={{ position: 'absolute', top: '15px', right: '10px', zIndex: 9999999 }}
                                      onClick={() => onClose()}
                                    >
                                      <MdOutlineClose fontSize={18} color="#ffffff" />
                                    </idk-div>
                                    {layout?.popupSettings?.showShareBtn && (
                                      <SharePopUp
                                        handleSharePopup={handleSharePopup}
                                        showSharePopup={showSharePopup}
                                        data={albumData[index]}
                                        isShopify={isShopify}
                                      />
                                    )}

                                    {((width <= 576 && layout.gallerySettings.showModalProducts) ||
                                      layout?.popupSettings?.showPostDescription == false) && (
                                      <ProductsOverlay
                                        isOpen={isOpen}
                                        shopifyData={shopifyData}
                                        row={albumData[index]}
                                        albumData={albumData}
                                        activeIndex={activeIndex}
                                      ></ProductsOverlay>
                                    )}
                                    {isFlag && (
                                      <idk-div
                                        class="zid-absolute zid-bottom-4 zid-right-4 zid-p-1 zid-cursor-pointer zid-bg-gray-200 zid-rounded-md"
                                        style={{ border: '1px solid #1C2833' }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          setReportModalData(albumData[index]);
                                          onReportModalOpen();
                                        }}
                                      >
                                        <FlagIcon width="20px" height="20px" fill="#1C2833" />
                                      </idk-div>
                                    )}
                                  </idk-div>
                                  {(layout?.popupSettings?.showPostDescription ||
                                    layout?.popupSettings?.showPostDescription == undefined) &&
                                    (isShopify &&
                                    layout?.gallerySettings?.showModalProducts &&
                                    albumData[index]?.products?.length > 0 ? (
                                      <idk-div
                                        class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                                        style={{ width: '350px' }}
                                      >
                                        <ShopifyModalRight
                                          quantity={quantity}
                                          updateQuantity={setQuantity}
                                          row={albumData[index]}
                                          shopifyData={shopifyData}
                                        />
                                      </idk-div>
                                    ) : isWooCommerceSite() &&
                                      layout?.gallerySettings?.showModalProducts &&
                                      albumData[index]?.products?.length > 0 ? (
                                      <idk-div
                                        class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                                        style={{ width: '350px' }}
                                      >
                                        <WocommerceModalRight
                                          quantity={quantity}
                                          updateQuantity={setQuantity}
                                          row={albumData[index]}
                                        />
                                      </idk-div>
                                    ) : (
                                      <idk-div
                                        class="zid-flex zid-flex-col zid-justify-between"
                                        style={{ width: '350px' }}
                                      >
                                        <idk-div>
                                          <idk-div
                                            class={`zid-hidden lg:zid-flex zid-items-center zid-gap-2 zid-p-4 zid-border-b zid-border-b-slate-200`}
                                          >
                                            <idk-div
                                              class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                                                albumData[index]?.profilePic != '0' &&
                                                albumData[index]?.profilePic != undefined &&
                                                albumData[index]?.username != '0' &&
                                                albumData[index]?.username != undefined
                                                  ? ''
                                                  : 'zid-invisible'
                                              }`}
                                            >
                                              {albumData[index]?.profilePic ? (
                                                <img
                                                  src={albumData[index]?.profilePic}
                                                  className="zid-h-full zid-w-full zid-rounded-full"
                                                  loading="lazy"
                                                  onError={(e) => {
                                                    const currentSrc = e.currentTarget.src;

                                                    // Only replace once if still pointing to idukki-cdn.com
                                                    if (currentSrc.includes('idukki-cdn.com')) {
                                                      e.currentTarget.onerror = null;
                                                      e.currentTarget.src = albumData[index]?.profilePic?.replace(
                                                        'https://idukki-cdn.com',
                                                        'https://assets.idukki.io',
                                                      );
                                                    }
                                                  }}
                                                ></img>
                                              ) : (
                                                albumData[index]?.username?.charAt(0)?.toUpperCase()
                                              )}
                                            </idk-div>
                                            {albumData[index]?.username != '0' && (
                                              <idk-div class="zid-text-black">{albumData[index]?.username}</idk-div>
                                            )}
                                          </idk-div>
                                          <idk-div
                                            class="zid-p-3 lg:zid-p-4 zid-text-slate-600 zid-hidden md:zid-block"
                                            style={{
                                              height: isGoogle ? '100%' : 'calc(90vh - 153px)',
                                              overflow: 'auto',
                                            }}
                                          >
                                            <idk-div class="zid-text-sm zid-whitespace-pre-wrap">
                                              {layout?.gallerySettings?.showPostCaption == false ? (
                                                <></>
                                              ) : (
                                                <ReadMoreReadLess totalWords={layout?.cardSettings?.descriptionWords}>
                                                  {albumData[index]?.caption}
                                                </ReadMoreReadLess>
                                              )}
                                            </idk-div>
                                            {!isHotspot &&
                                              products &&
                                              layout?.gallerySettings?.showModalProducts &&
                                              products?.length > 0 && (
                                                <idk-div class="zid-w-[100%] zid-overflow-auto">
                                                  <ModalHeader
                                                    modalData={albumData[index]}
                                                    closeModal={onClose}
                                                    show={!isHotspot}
                                                    isWooCommerceSite={isWooCommerceSite}
                                                    currency={data.result.currency}
                                                    shopifyData={shopifyData}
                                                    layout={layout}
                                                    clickMutate={clickMutate}
                                                    productReview={productReview}
                                                  />
                                                </idk-div>
                                              )}
                                          </idk-div>
                                        </idk-div>
                                        <idk-div class="zid-hidden md:zid-flex zid-items-center zid-justify-between zid-border-t zid-border-t-slate-200 zid-p-3 lg:zid-p-4">
                                          <idk-div>
                                            <idk-div class="zid-flex zid-mb-2 zid-gap-4">
                                              {albumData[index]?.like_count && albumData[index]?.like_count != 0 ? (
                                                <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                                  <img
                                                    src="https://assets.idukki.io/widget-assets/HeartOutlineFill.svg"
                                                    loading="lazy"
                                                    height="20px"
                                                    width="20px"
                                                  />
                                                  <idk-div>{albumData[index]?.like_count}</idk-div>
                                                </idk-div>
                                              ) : (
                                                ''
                                              )}
                                              {albumData[index]?.comments_count &&
                                              albumData[index]?.comments_count != 0 ? (
                                                <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                                  <img
                                                    src="https://assets.idukki.io/widget-assets/CommentOutline.svg"
                                                    loading="lazy"
                                                    height="20px"
                                                    width="20px"
                                                  />
                                                  <idk-div>{albumData[index]?.comments_count}</idk-div>
                                                </idk-div>
                                              ) : (
                                                ''
                                              )}
                                            </idk-div>
                                            <idk-p class="zid-text-slate-600 zid-text-sm">
                                              {(layout?.popupSettings?.showPopupTimeline ||
                                                layout?.popupSettings?.showPopupTimeline == undefined) &&
                                                albumData[index]?.timestamp &&
                                                dayjs(albumData[index]?.timestamp).fromNow()}
                                            </idk-p>
                                          </idk-div>
                                          <idk-div class="zid-flex zid-flex-col zid-items-end">
                                            <idk-div class="zid-text-sky-800 hover:zid-underline zid-flex zid-gap-2">
                                              {albumData[index]?.source == 'Youtube' && (
                                                <img
                                                  height={25}
                                                  width={25}
                                                  src="https://assets.idukki.io/widget-assets/YoutubeLogo.svg"
                                                  loading="lazy"
                                                ></img>
                                              )}
                                              {albumData[index]?.source == 'Shorts' && (
                                                <img
                                                  height={25}
                                                  width={25}
                                                  src="https://assets.idukki.io/widget-assets/ShortsLogo.svg"
                                                  loading="lazy"
                                                ></img>
                                              )}
                                              {albumData[index]?.source == 'Instagram_business' && (
                                                <img
                                                  height={25}
                                                  width={25}
                                                  src="https://assets.idukki.io/widget-assets/InstagramLogo.svg"
                                                  loading="lazy"
                                                ></img>
                                              )}
                                              {albumData[index]?.source == 'Twitter' && (
                                                <img
                                                  height={25}
                                                  width={25}
                                                  src="https://assets.idukki.io/widget-assets/XTwitterLogo.svg"
                                                  loading="lazy"
                                                ></img>
                                              )}
                                              {albumData[index]?.source == 'Tiktok' && (
                                                <FaTiktok height={25} width={25} className="zid-text-[#000]" />
                                              )}

                                              {albumData[index]?.permalink && (
                                                <a href={albumData[index]?.permalink} target="_blank">
                                                  View Post
                                                </a>
                                              )}
                                            </idk-div>
                                            {(layout?.popupSettings?.showPoweredBy ||
                                              layout?.popupSettings?.showPoweredBy == undefined) && (
                                              <PoweredBy
                                                layout={layout}
                                                onPost={true}
                                                guid={guid}
                                                className="zid-p-0 zid-mr-0"
                                              />
                                            )}
                                          </idk-div>
                                        </idk-div>
                                      </idk-div>
                                    ))}
                                </idk-div>
                              </idk-div>
                            </idk-div>
                            <idk-div
                              class="zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col zid-right-[10px]"
                              style={{ top: '50%', transform: 'translateY(-50%)' }}
                            >
                              <idk-div
                                onClick={handlePrev}
                                style={{ backdropFilter: 'blur(10px)' }}
                                class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                              >
                                <MdKeyboardArrowUp color="#fff" fontSize={30} />
                              </idk-div>
                              <idk-div
                                onClick={handleNext}
                                style={{ backdropFilter: 'blur(10px)' }}
                                class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                              >
                                <MdKeyboardArrowDown color="#fff" fontSize={30} />
                              </idk-div>
                            </idk-div>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </idk-div>
                ) : layout?.gallerySettings?.modalDesign === 'carousel' ? (
                  <idk-div class="zid-mx-auto zid-max-w-[40vw] zid-relative">
                    <style>
                      {`.carousel_content_modal .carousel_content_modal_slide {
                          width: 350px !important;
                          height: 85vh !important;
                          max-height: 850px !important;
                        }
                      `}
                    </style>
                    <Swiper
                      modules={[EffectCoverflow]}
                      effect="coverflow"
                      centeredSlides
                      slidesPerView="auto"
                      grabCursor
                      loop
                      speed={800}
                      pagination={{ clickable: true }}
                      navigation
                      initialSlide={activeIndex ?? 0}
                      onSwiper={(swiper) => (swiperRef.current = swiper)}
                      onSlideChange={(slider) => {
                        setActiveIndex(slider.realIndex);
                        clickMutate(albumData[`${slider.activeIndex}`]?.id);
                        handleSlide(slider);
                        if (slider.isEnd) {
                          fetchNextPost();
                        }
                      }}
                      coverflowEffect={{
                        rotate: -5,
                        stretch: 10,
                        depth: 400,
                        modifier: 1,
                        slideShadows: true,
                      }}
                      className="carousel_content_modal"
                    >
                      {albumData.map((mediaData, index) => {
                        return (
                          <SwiperSlide key={index} className="carousel_content_modal_slide zid-relative zid-w-full">
                            <HotspotMedia
                              layout={layout}
                              isSwiper={true}
                              onVideoComplete={onVideoComplete}
                              autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
                              isMuted={layout?.popupSettings?.popupVideoMute}
                              showMute={true}
                              playFunctionality={true}
                              row={mediaData}
                              isModal={true}
                              style={{
                                height: '100%',
                                width: '100%',
                                objectFit: 'cover',
                                maxHeight: isGoogle ? '90vh' : '100%',
                              }}
                            />
                            {activeIndex == index && (
                              <ProductOutside
                                isOpen={isOpen}
                                shopifyData={shopifyData}
                                row={albumData[activeIndex]}
                                albumData={albumData}
                                activeIndex={activeIndex}
                              />
                            )}
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                    <idk-div
                      class="zid-cursor-pointer zid-absolute zid-z-[100] zid-gap-3 zid-flex-col zid-left-[-80px] zid-h-[40px] zid-w-[40px] zid-bg-white zid-flex zid-items-center zid-justify-center zid-rounded-full"
                      style={{ top: '50%', transform: 'translateY(-50%)' }}
                      onClick={handlePrev}
                    >
                      <IoIosArrowBack fontSize={22} className="zid-cursor-pointer" />
                    </idk-div>
                    <idk-div
                      class="zid-cursor-pointer zid-absolute zid-z-[100] zid-gap-3 zid-flex-col zid-right-[-80px] zid-h-[40px] zid-w-[40px] zid-bg-white zid-flex zid-items-center zid-justify-center zid-rounded-full"
                      style={{ top: '50%', transform: 'translateY(-50%)' }}
                      onClick={handleNext}
                    >
                      <IoIosArrowForward fontSize={22} className="zid-cursor-pointer" />
                    </idk-div>
                    <idk-div class="zid-cursor-pointer zid-absolute zid-z-[100]z zid-top-0 zid-right-[-80px] zid-flex zid-items-center zid-justify-center">
                      <MdOutlineClose
                        fontSize={30}
                        color="#fff"
                        onClick={() => onClose()}
                        className="zid-cursor-pointer"
                      />
                    </idk-div>
                  </idk-div>
                ) : (
                  <idk-div class="zid-bg-white zid-w-full zid-h-full zid-rounded" style={{ maxHeight: '100vh' }}>
                    <idk-div class="zid-flex zid-flex-col sm:zid-flex-row zid-h-full zid-relative zid-border-2 zid-rounded">
                      {layout?.popupSettings?.showPostDescription == false && (
                        <>
                          <idk-div
                            class="idk_close_modal_icon zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px] zid-z-[99] zid-absolute zid-cursor-pointer"
                            style={{ right: '10px', top: '15px' }}
                          >
                            <MdOutlineClose fontSize={20} color="#fff" onClick={() => onClose()} />
                          </idk-div>
                          {layout?.popupSettings?.showShareBtn && (
                            <SharePopUp
                              handleSharePopup={handleSharePopup}
                              showSharePopup={showSharePopup}
                              data={albumData[activeIndex]}
                              isShopify={isShopify}
                            />
                          )}
                        </>
                      )}

                      <idk-div
                        class="zid-flex zid-w-full zid-h-full zid-bg-white zid-relative"
                        style={{ flexDirection: width <= 576 && isGoogle ? 'column' : 'row' }}
                      >
                        <idk-div
                          id="idk_modal_close_btn"
                          class="zid-cursor-pointer zid-absolute zid-h-[24px] zid-w-[24px] zid-flex zid-items-center zid-justify-center zid-bg-white zid-rounded-full -zid-top-3 -zid-right-3 zid-z-10"
                          onClick={() => onClose()}
                        >
                          <IoClose color="#000000" fontSize={20} />
                        </idk-div>
                        <idk-div
                          class="zid-absolute zid-w-full zid-z-[999999] zid-top-0"
                          id="idk_top_content"
                        ></idk-div>
                        <idk-div
                          class={`${
                            !isGoogle ? 'zid-hidden' : ''
                          } lg:zid-hidden zid-items-center zid-gap-2 zid-p-3 zid-border-b zid-border-b-slate-200 zid-md-flex`}
                        >
                          <idk-div
                            class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                              albumData[activeIndex]?.profilePic != '0' &&
                              albumData[activeIndex]?.profilePic != undefined &&
                              albumData[activeIndex]?.username != '0' &&
                              albumData[activeIndex]?.username != undefined
                                ? ''
                                : 'zid-invisible'
                            }`}
                          >
                            {albumData[activeIndex]?.profilePic ? (
                              <img
                                src={albumData[activeIndex]?.profilePic}
                                onError={(e) => {
                                  const currentSrc = e.currentTarget.src;

                                  // Only replace once if still pointing to idukki-cdn.com
                                  if (currentSrc.includes('idukki-cdn.com')) {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = albumData[activeIndex]?.profilePic?.replace(
                                      'https://idukki-cdn.com',
                                      'https://assets.idukki.io',
                                    );
                                  }
                                }}
                                className="zid-h-full zid-w-full zid-rounded-full"
                                loading="lazy"
                              ></img>
                            ) : (
                              albumData[activeIndex]?.username?.charAt(0)?.toUpperCase()
                            )}
                          </idk-div>
                          {albumData[activeIndex]?.username != '0' && (
                            <idk-div class="zid-text-black">{albumData[activeIndex]?.username}</idk-div>
                          )}
                        </idk-div>
                        <idk-div class="zid-relative zid-h-full">
                          <HotspotMedia
                            layout={layout}
                            autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
                            isMuted={layout?.popupSettings?.popupVideoMute}
                            onVideoComplete={onVideoComplete}
                            showMute={true}
                            playFunctionality={true}
                            row={albumData[activeIndex]}
                            isModal={true}
                            style={{
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover',
                              maxHeight: isGoogle ? '90vh' : '100%',
                            }}
                          />
                          <idk-div
                            class={`zid-bg-[#0000004d] zid-rounded zid-flex md:zid-hidden zid-items-center zid-justify-center zid-h-[30px] zid-w-[30px] ${
                              isGoogle ? 'zid-hidden' : ''
                            }`}
                            style={{ position: 'absolute', top: '15px', right: '10px' }}
                            onClick={() => onClose()}
                          >
                            <MdOutlineClose fontSize={18} color="#ffffff" />
                          </idk-div>

                          {((width <= 576 && layout.gallerySettings.showModalProducts) ||
                            layout?.popupSettings?.showPostDescription == false) && (
                            <ProductsOverlay
                              isOpen={isOpen}
                              shopifyData={shopifyData}
                              row={albumData[activeIndex]}
                              albumData={albumData}
                              activeIndex={activeIndex}
                            ></ProductsOverlay>
                          )}
                          {isFlag && (
                            <idk-div
                              class="zid-absolute zid-bottom-4 zid-right-4 zid-p-1 zid-cursor-pointer zid-bg-gray-200 zid-rounded-md"
                              style={{ border: '1px solid #1C2833' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setReportModalData(albumData[activeIndex]);
                                onReportModalOpen();
                              }}
                            >
                              <FlagIcon width="20px" height="20px" fill="#1C2833" />
                            </idk-div>
                          )}
                        </idk-div>
                        {(layout?.popupSettings?.showPostDescription ||
                          layout?.popupSettings?.showPostDescription == undefined) &&
                          (isShopify &&
                          layout?.gallerySettings?.showModalProducts &&
                          albumData[activeIndex]?.products?.length > 0 ? (
                            <idk-div
                              class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                              style={{ width: '350px' }}
                            >
                              <ShopifyModalRight
                                quantity={quantity}
                                updateQuantity={setQuantity}
                                row={albumData[activeIndex]}
                                shopifyData={shopifyData}
                              />
                            </idk-div>
                          ) : isWooCommerceSite() && albumData[activeIndex]?.products?.length > 0 ? (
                            <idk-div
                              class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                              style={{ width: '350px' }}
                            >
                              <WocommerceModalRight
                                quantity={quantity}
                                updateQuantity={setQuantity}
                                row={albumData[activeIndex]}
                              />
                            </idk-div>
                          ) : window?.location?.host?.includes('biba.in') ? (
                            <idk-div
                              class="zid-hidden md:zid-flex zid-flex-col zid-justify-between"
                              style={{ width: '350px' }}
                            >
                              <AdditionalModalRight
                                quantity={quantity}
                                updateQuantity={setQuantity}
                                row={albumData[activeIndex]}
                              />
                            </idk-div>
                          ) : (
                            <idk-div class="zid-flex zid-flex-col zid-justify-between" style={{ width: '350px' }}>
                              <idk-div>
                                <idk-div
                                  class={`zid-hidden lg:zid-flex zid-items-center zid-gap-2 zid-p-4 zid-border-b zid-border-b-slate-200`}
                                >
                                  <idk-div
                                    class={`zid-h-8 zid-w-8 zid-bg-slate-300 zid-rounded-full zid-flex zid-items-center zid-justify-center zid-text-white ${
                                      albumData[activeIndex]?.profilePic != '0' &&
                                      albumData[activeIndex]?.profilePic != undefined &&
                                      albumData[activeIndex]?.username != '0' &&
                                      albumData[activeIndex]?.username != undefined
                                        ? ''
                                        : 'zid-invisible'
                                    }`}
                                  >
                                    {albumData[activeIndex]?.profilePic &&
                                    albumData[activeIndex]?.profilePic !== '0' ? (
                                      <img
                                        src={albumData[activeIndex]?.profilePic}
                                        onError={(e) => {
                                          const currentSrc = e.currentTarget.src;

                                          // Only replace once if still pointing to idukki-cdn.com
                                          if (currentSrc.includes('idukki-cdn.com')) {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = albumData[activeIndex]?.profilePic?.replace(
                                              'https://idukki-cdn.com',
                                              'https://assets.idukki.io',
                                            );
                                          }
                                        }}
                                        className="zid-h-full zid-w-full zid-rounded-full"
                                        loading="lazy"
                                      ></img>
                                    ) : (
                                      albumData[activeIndex]?.username?.charAt(0)?.toUpperCase()
                                    )}
                                  </idk-div>
                                  {albumData[activeIndex]?.username != '0' && (
                                    <idk-div class="zid-text-black">{albumData[activeIndex]?.username}</idk-div>
                                  )}
                                </idk-div>
                                <idk-div
                                  class={`zid-p-3 lg:zid-p-4 zid-text-slate-600 ${
                                    !isGoogle ? 'zid-hidden' : ''
                                  } md:zid-block`}
                                  style={{ height: isGoogle ? '100%' : 'calc(90vh - 153px)', overflow: 'auto' }}
                                >
                                  <idk-div class="zid-text-sm zid-whitespace-pre-wrap">
                                    {layout?.gallerySettings?.showPostCaption == false ? (
                                      <></>
                                    ) : isGoogle ? (
                                      albumData?.[activeIndex]?.caption
                                    ) : (
                                      <ReadMoreReadLess totalWords={layout?.cardSettings?.descriptionWords}>
                                        {albumData[activeIndex]?.caption}
                                      </ReadMoreReadLess>
                                    )}
                                  </idk-div>
                                  {!isHotspot &&
                                  products &&
                                  layout?.gallerySettings?.showModalProducts &&
                                  products?.length > 0 ? (
                                    <idk-div class="zid-w-[100%] zid-overflow-auto">
                                      <ModalHeader
                                        modalData={albumData[activeIndex]}
                                        closeModal={onClose}
                                        show={!isHotspot}
                                        currency={data?.result?.currency}
                                        isWooCommerceSite={isWooCommerceSite}
                                        shopifyData={shopifyData}
                                        layout={layout}
                                        clickMutate={clickMutate}
                                        productReview={productReview}
                                      />
                                    </idk-div>
                                  ) : (
                                    <></>
                                  )}
                                </idk-div>
                              </idk-div>
                              <idk-div
                                class={`${
                                  !isGoogle ? 'zid-hidden' : ''
                                } md:zid-flex zid-items-center zid-justify-between zid-border-t zid-border-t-slate-200 zid-p-3 lg:zid-p-4`}
                              >
                                <idk-div>
                                  <idk-div class="zid-flex zid-mb-2 zid-gap-4">
                                    {albumData[activeIndex]?.like_count && albumData[activeIndex]?.like_count != 0 ? (
                                      <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                        <img
                                          src="https://assets.idukki.io/widget-assets/HeartOutlineFill.svg"
                                          loading="lazy"
                                          height="20px"
                                          width="20px"
                                        />
                                        <idk-div>{albumData[activeIndex]?.like_count}</idk-div>
                                      </idk-div>
                                    ) : (
                                      ''
                                    )}
                                    {albumData[activeIndex]?.comments_count &&
                                    albumData[activeIndex]?.comments_count != 0 ? (
                                      <idk-div class="zid-flex zid-gap-1 zid-items-center">
                                        <img
                                          src="https://assets.idukki.io/widget-assets/CommentOutline.svg"
                                          loading="lazy"
                                          height="20px"
                                          width="20px"
                                        />
                                        <idk-div>{albumData[activeIndex]?.comments_count}</idk-div>
                                      </idk-div>
                                    ) : (
                                      ''
                                    )}
                                  </idk-div>
                                  <idk-p class="zid-text-slate-600 zid-text-sm">
                                    {(layout?.popupSettings?.showPopupTimeline ||
                                      layout?.popupSettings?.showPopupTimeline == undefined) &&
                                      albumData[activeIndex]?.timestamp &&
                                      dayjs(albumData[activeIndex]?.timestamp).fromNow()}
                                  </idk-p>
                                </idk-div>
                                <idk-div class="zid-flex zid-flex-col zid-items-end">
                                  <idk-div class="zid-text-sky-800 hover:zid-underline zid-flex zid-gap-2">
                                    {albumData[activeIndex]?.source == 'Youtube' && (
                                      <img
                                        height={25}
                                        width={25}
                                        src="https://assets.idukki.io/widget-assets/YoutubeLogo.svg"
                                        loading="lazy"
                                      ></img>
                                    )}
                                    {albumData[activeIndex]?.source == 'Shorts' && (
                                      <img
                                        height={25}
                                        width={25}
                                        src="https://assets.idukki.io/widget-assets/ShortsLogo.svg"
                                        loading="lazy"
                                      ></img>
                                    )}
                                    {albumData[activeIndex]?.source == 'Instagram_business' && (
                                      <img
                                        height={25}
                                        width={25}
                                        src="https://assets.idukki.io/widget-assets/InstagramLogo.svg"
                                        loading="lazy"
                                      ></img>
                                    )}
                                    {albumData[activeIndex]?.source == 'Twitter' && (
                                      <img
                                        height={25}
                                        width={25}
                                        src="https://assets.idukki.io/widget-assets/XTwitterLogo.svg"
                                        loading="lazy"
                                      ></img>
                                    )}
                                    {albumData[activeIndex]?.source == 'Tiktok' && (
                                      <FaTiktok height={25} width={25} className="zid-text-[#000]" />
                                    )}

                                    {albumData[activeIndex]?.permalink && (
                                      <a href={albumData[activeIndex]?.permalink} target="_blank">
                                        View Post
                                      </a>
                                    )}
                                  </idk-div>
                                  {(layout?.popupSettings?.showPoweredBy ||
                                    layout?.popupSettings?.showPoweredBy == undefined) && (
                                    <PoweredBy layout={layout} onPost={true} guid={guid} className="zid-p-0 zid-mr-0" />
                                  )}
                                </idk-div>
                              </idk-div>
                            </idk-div>
                          ))}
                      </idk-div>
                    </idk-div>
                  </idk-div>
                ))}
            </idk-div>
          </idk-div>
        </>
      )}
    </AnimatedModal>
  );
};

const SharePopUp = ({ showSharePopup, handleSharePopup, data, isShopify }) => {
  const [copySuccess, setCopySuccess] = React.useState('');

  const product = data?.products?.[0];
  const baseUrl =
    (isShopify && product?.handle && `https://${window.location.host}/products/${product.handle}`) ||
    product?.product_url ||
    data?.permalink ||
    window.location.href;

  const utmParams = new URLSearchParams({
    utm_source: data?.layout?.gallerySettings?.utmSource || 'IdukkiUGC',
    utm_medium: data?.layout?.gallerySettings?.utmMedium || 'Share',
    utm_campaign: data?.layout?.gallerySettings?.utmCampaign || 'ShoppableVideos',
  }).toString();

  const shareUrl = baseUrl.includes('?') ? `${baseUrl}&${utmParams}` : `${baseUrl}?${utmParams}`;

  const message = `Check this out: ${shareUrl}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch {
      setCopySuccess('Copy failed');
    }
  };

  const handleWhatsAppShare = () =>
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
  const handleTwitterShare = () =>
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`, '_blank');
  const handleFacebookShare = () =>
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
  const handleLinkedInShare = () =>
    window.open(`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(shareUrl)}`, '_blank');

  return (
    <>
      <idk-div
        class="idk_share_modal_icon zid-bg-[#0000004d] zid-rounded zid-flex zid-items-center zid-justify-center zid-h-[35px] zid-w-[35px]"
        style={{
          position: 'absolute',
          bottom: '70px',
          right: '10px',
          zIndex: 9999999,
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleSharePopup();
        }}
      >
        <FaShare fontSize={18} color="#fff" />
      </idk-div>

      <idk-div
        class={`zid-fixed zid-left-0 zid-bottom-0 zid-w-full zid-bg-white zid-rounded-t-2xl zid-shadow-2xl zid-transition-transform zid-duration-300 ${
          showSharePopup ? 'zid-translate-y-0' : 'zid-translate-y-full'
        }`}
        style={{
          zIndex: 999999999,
          padding: '20px 0 40px 0',
          boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
        }}
      >
        {/* Header */}
        <idk-div class="zid-relative zid-flex zid-justify-center zid-items-center zid-pb-3 zid-border-b zid-border-gray-100">
          <idk-p class="zid-text-base zid-font-semibold">Share</idk-p>
          <MdOutlineClose
            className="zid-absolute zid-right-5 zid-top-1/2 -zid-translate-y-1/2 zid-cursor-pointer"
            size={22}
            color="#000"
            onClick={handleSharePopup}
          />
        </idk-div>

        <idk-div class="zid-flex zid-justify-center zid-gap-8 zid-pt-5 zid-flex-wrap">
          <idk-div
            class="zid-flex zid-flex-col zid-items-center zid-gap-1 zid-cursor-pointer"
            onClick={handleFacebookShare}
          >
            <idk-div class="zid-h-12 zid-w-12 zid-bg-[#1877F2] zid-rounded-full zid-flex zid-items-center zid-justify-center">
              <FaFacebookF color="#fff" size={20} />
            </idk-div>
            <idk-span class="zid-text-xs zid-font-medium">Facebook</idk-span>
          </idk-div>

          <idk-div
            class="zid-flex zid-flex-col zid-items-center zid-gap-1 zid-cursor-pointer"
            onClick={handleLinkedInShare}
          >
            <idk-div class="zid-h-12 zid-w-12 zid-bg-[#0077B5] zid-rounded-full zid-flex zid-items-center zid-justify-center">
              <FaLinkedinIn color="#fff" size={20} />
            </idk-div>
            <idk-span class="zid-text-xs zid-font-medium">LinkedIn</idk-span>
          </idk-div>

          <idk-div
            class="zid-flex zid-flex-col zid-items-center zid-gap-1 zid-cursor-pointer"
            onClick={handleWhatsAppShare}
          >
            <idk-div class="zid-h-12 zid-w-12 zid-bg-[#25D366] zid-rounded-full zid-flex zid-items-center zid-justify-center">
              <FaWhatsapp color="#fff" size={22} />
            </idk-div>
            <idk-span class="zid-text-xs zid-font-medium">WhatsApp</idk-span>
          </idk-div>

          <idk-div
            class="zid-flex zid-flex-col zid-items-center zid-gap-1 zid-cursor-pointer"
            onClick={handleTwitterShare}
          >
            <idk-div class="zid-h-12 zid-w-12 zid-bg-[#000000] zid-rounded-full zid-flex zid-items-center zid-justify-center">
              <FaSquareXTwitter color="#fff" size={22} />
            </idk-div>
            <idk-span class="zid-text-xs zid-font-medium">X</idk-span>
          </idk-div>

          <idk-div
            class="zid-flex zid-flex-col zid-items-center zid-gap-1 zid-cursor-pointer"
            onClick={copyToClipboard}
          >
            <idk-div class="zid-h-12 zid-w-12 zid-bg-[#E4E6EB] zid-rounded-full zid-flex zid-items-center zid-justify-center">
              <BsCopy color="#000" size={20} />
            </idk-div>
            <idk-span class="zid-text-xs zid-font-medium">{copySuccess ? copySuccess : 'Copy link'}</idk-span>
          </idk-div>
        </idk-div>
      </idk-div>
    </>
  );
};

const ModalHeader = ({
  modalData,
  closeModal,
  show,
  currency,
  isWooCommerceSite,
  shopifyData,
  layout,
  clickMutate,
  productReview,
}) => {
  const ShopBtnComponent = ({ product }) => {
    const websiteArr = ['widgetugc.feefo.com', 'idukki-cdn.com', 'widget.idukki.io', 'widget-staging.idukki.io'];
    const btnRef = useRef();
    return (
      <>
        <style>{`
        .idk_shop_now_btn {
        ${layout?.productsSettings?.shopBtnCss}
        }
        `}</style>
        <idk-div
          ref={btnRef}
          onClick={() => {
            clickMutate(modalData.id, {
              event: 'add_to_cart',
              price: product?.variants?.[0]?.salePrice,
              productId: product?.id_from_product,
            });
            const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionalityOverlay;
            if (shopBtnFunctionality) {
              try {
                const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                func(modalData, product, btnRef);
              } catch (error) {
                console.error('Error executing shopBtnFunctionality', error);
              }
            } else {
              window.open(
                product?.product_url
                  ? `${product.product_url}?utm_source=${
                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                    }`
                  : !websiteArr.includes(window.location.hostname)
                  ? `https://${window.location.hostname}`
                  : 'https://app.idukki.io/register',
                '_blank',
              );
            }
          }}
          class="zid-w-max zid-rounded-md zid-bg-blue-600 zid-px-4 zid-py-1 zid-text-[12px] zid-text-white zid-cursor-pointer zid-min-w-[100px] idk_shop_now_btn"
          dangerouslySetInnerHTML={{ __html: layout?.productsSettings?.shopBtnText || 'Add to cart' }}
        ></idk-div>
      </>
    );
  };

  return (
    <>
      <style>
        {` 
      .idk_btn_price_container{
        ${layout?.productsSettings?.priceBtnContainerCss}}`}
      </style>
      <idk-div class="zid-flex zid-flex-col zid-justify-between zid-overflow-x-hidden zid-overflow-auto zid-w-full zid-relative">
        <idk-div class="zid-flex zid-flex-col">
          {show && (
            <idk-div class="zid-flex zid-flex-col zid-text-gray-700 zid-text-[18px] zid-gap-4 zid-h-full">
              <idk-div class="zid-flex zid-justify-between zid-pr-[50px]">
                <idk-div class="zid-flex zid-gap-2">
                  {modalData?.logo && (
                    <idk-div class="zid-border-2 zid-border-solid zid-h-[40px] zid-w-[40px] zid-overflow-hidden zid-rounded-[999px]">
                      <img
                        src={modalData?.logo}
                        onError={(e) => {
                          const currentSrc = e.currentTarget.src;

                          // Only replace once if still pointing to idukki-cdn.com
                          if (currentSrc.includes('idukki-cdn.com')) {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = modalData?.logo?.replace(
                              'https://idukki-cdn.com',
                              'https://assets.idukki.io',
                            );
                          }
                        }}
                        className="zid-w-full"
                        loading="lazy"
                      />
                    </idk-div>
                  )}
                  {modalData?.product_name && (
                    <idk-div class="zid-flex zid-gap-[1px] zid-flex-col zid-text-[14px] zid-leading-[14px] zid-justify-center">
                      <idk-p>{modalData?.product_name}</idk-p>
                    </idk-div>
                  )}
                </idk-div>
              </idk-div>

              <idk-div class="zid-flex zid-flex-wrap zid-w-full zid-flex-col zid-text-[12px] zid-break-words zid-modal-productdetail-container">
                {modalData?.description && <idk-p class="zid-mb-4">{modalData?.description}</idk-p>}
                <idk-div class="zid-flex zid-flex-col zid-w-full zid-gap-6">
                  <>
                    {modalData?.products?.map((product, id1: number) => {
                      return (
                        <idk-div key={id1}>
                          <idk-div key={id1} class="zid-flex zid-w-full zid-justify-between zid-gap-2">
                            {(product?.images || product?.image) && (
                              <idk-div
                                class=" zid-rounded zid-flex zid-items-center zid-white zid-img-product-modal"
                                style={{ width: '80px', height: '80px', overflow: 'hidden', flex: '0 0 80px' }}
                              >
                                <img
                                  onClick={() => {
                                    window.open(
                                      shopifyData
                                        ? `https://${window.location.host}/products/${product?.handle}`
                                        : `${product?.product_url}?utm_source=${
                                            layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                          }&utm_medium=${
                                            layout?.gallerySettings?.utmMedium || 'AddToCart'
                                          }&utm_campaign=${
                                            layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                          }`,
                                      '_blank',
                                    );
                                  }}
                                  src={
                                    product?.images?.[0]?.image_url?.replaceAll('resize/800x800', 'resize/64x64') ||
                                    product?.image?.replaceAll('resize/800x800', 'resize/64x64')
                                  }
                                  className="zid-w-full zid-h-full zid-object-contain"
                                  loading="lazy"
                                  onError={(e) => {
                                    const currentSrc = e.currentTarget.src;

                                    // Only replace once if still pointing to idukki-cdn.com
                                    if (currentSrc.includes('idukki-cdn.com')) {
                                      e.currentTarget.onerror = null;
                                      e.currentTarget.src = product?.images[0]?.image_url
                                        ?.replaceAll('resize/800x800', 'resize/64x64')
                                        ?.replace('https://idukki-cdn.com', 'https://assets.idukki.io');
                                    }
                                  }}
                                />
                              </idk-div>
                            )}
                            <idk-div
                              class="zid-flex zid-gap-[10px] zid-text-[12px] zid-flex-col zid-overflow-hidden"
                              style={{ flexGrow: 1 }}
                            >
                              <idk-p
                                onClick={() => {
                                  clickMutate(modalData.id, {
                                    event: CLICK_EVENTS.PDP_REDIRECT,
                                    productId: product?.id_from_product ?? product?.id,
                                  });
                                  window.open(
                                    shopifyData
                                      ? `https://${window.location.host}/products/${product?.handle}`
                                      : `${product?.product_url}?utm_source=${
                                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                        }&utm_medium=${
                                          layout?.gallerySettings?.utmMedium || 'AddToCart'
                                        }&utm_campaign=${
                                          layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                        }`,
                                    '_blank',
                                  );
                                }}
                                class="zid-font-bold zid-text-base zid-modal-product-title"
                                style={{ fontSize: '14px' }}
                              >
                                {product?.title}
                              </idk-p>
                              {layout?.productsSettings?.showProductRating && product?.productReview && (
                                <PostRating
                                  rating={product?.productReview?.rating}
                                  totalUsers={product?.productReview?.totalReview}
                                  color={layout?.productsSettings?.productRatingStarColor}
                                  url={
                                    layout?.productsSettings?.productRatingUrl
                                      ? layout?.productsSettings?.productRatingUrl
                                      : shopifyData
                                      ? `https://${window.location.host}/products/${product?.handle}`
                                      : `${product?.product_url}?utm_source=${
                                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                        }&utm_medium=${
                                          layout?.gallerySettings?.utmMedium || 'StarRating'
                                        }&utm_campaign=${layout?.gallerySettings?.utmCampaign || 'ShoppableVideos'}`
                                  }
                                />
                              )}

                              {product?.description &&
                                product?.description?.trim() &&
                                layout?.productsSettings?.showProductDescription && (
                                  <idk-p
                                    class="zid-modal-product-description"
                                    dangerouslySetInnerHTML={{ __html: product?.description }}
                                  ></idk-p>
                                )}
                              <idk-div class="idk_btn_price_container">
                                {!layout?.productsSettings?.hideProductPrice && product?.variants && (
                                  <idk-p
                                    class="zid-mt-1 zid-p-0 zid-mb-0 zid-font-bold"
                                    style={{ fontSize: '14px', minWidth: '100px' }}
                                  >
                                    {isWooCommerceSite() &&
                                      !currency &&
                                      document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                        ?.innerHTML}
                                    {shopifyData?.currency?.active &&
                                      !currency &&
                                      getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                    <span className="zid-font-bold">
                                      <PriceDisplay
                                        price={product?.variants?.[0]?.price}
                                        salePrice={product?.variants?.[0]?.salePrice}
                                        currency={currency}
                                      />
                                    </span>
                                  </idk-p>
                                )}
                                <idk-div class="zid-flex  zid-items-center zid-mt-1">
                                  <ShopBtnComponent product={product} />
                                </idk-div>
                              </idk-div>
                            </idk-div>
                          </idk-div>
                          {layout?.productsSettings?.showProductReviews && productReview[product?.id_from_product] && (
                            <ProductReviews
                              color={layout?.productsSettings?.productRatingStarColor}
                              reviewData={productReview[product?.id_from_product]}
                              layout={layout}
                            />
                          )}
                        </idk-div>
                      );
                    })}
                  </>
                </idk-div>
              </idk-div>
            </idk-div>
          )}
        </idk-div>
      </idk-div>
    </>
  );
};

export default memo(Modal);
